import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { IExhibitorPair } from "@evennt-tech/api-v2-core";
import { registerStore } from "store/utils/reset-store.utils";

export enum ViewMode {
  EXHIBITOR = "exhibitor",
}

type State = {
  mode?: ViewMode;
  isViewOnly: boolean;
  mocked: {
    exhibitor?: IExhibitorPair;
  };
};

type Action = {
  setState: (params: {
    mode?: ViewMode;
    isViewOnly?: boolean;
    exhibitor?: IExhibitorPair;
  }) => void;
};

const useViewMode = create(
  devtools<State & Action>((set) => ({
    mode: undefined,
    isViewOnly: false,
    mocked: {},
    setState: (params) =>
      set((old) => ({
        mode: params.mode ?? old.mode,
        isViewOnly: params.isViewOnly ?? old.isViewOnly,
        mocked: {
          exhibitor: params.exhibitor ?? old.mocked.exhibitor,
        },
      })),
  }))
);

export default useViewMode;

registerStore(useViewMode);
